import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LogoIcon from "../../assets/svg/logoIcon";
import { useAuth } from "../../context/authContext";
import createAxiosInstance from "../../utils/axiosConfig";
import { change_password } from "../../utils/endpoints";
import { validate } from "../../utils/formValidate";
import Alert from "../common/alerts/alert";
import BackButton from "../common/backButton";
import ChatHistory from "../common/chatHistory";
import Footer from "../common/footer";

const ChangePassword = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const { isAuthenticated, logout } = useAuth();
	const [formData, setFormData] = useState({
		oldPassword: "",
		password: "",
		confirmPassword: "",
	});

	const [errors, setErrors] = useState<any>({});
	const [responseError, setResponseError] = useState<any>("");
	const [alertVisible, setAlertVisible] = useState(false);
	const [loading, setLoading] = useState(false);

	// safely handle user authentication ...
	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const token = queryParams.get("token");
		if (token) {
			// If a token exists in query parameters, save it to localStorage
			localStorage.setItem("changePasswordToken", token);
		} else {
			// user isn't authenticated already.
			if (!isAuthenticated) {
				navigate("/login");
			}
		}
	}, [location]);

	const handleChange = (
		e: React.ChangeEvent<
			HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
		>
	) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
		validate({ [name]: value }, setErrors);

		// Confirm password validation
		if (name === "confirmPassword") {
			if (value !== formData.password) {
				setErrors({ ...errors, confirmPassword: "Passwords do not match." });
			} else {
				setErrors({ ...errors, confirmPassword: "" });
			}
		}
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		if (!validate(formData, setErrors)) return;
		setLoading(true);
		const userData = localStorage.getItem("userData");
		const payload = {
			new_password: formData.password,
			email: "",
		};

		if (!userData) {
			logout();
			navigate("/");
			return;
		} else {
			payload.email = JSON.parse(userData)?.email;
		}

		try {
			const axiosInstance = createAxiosInstance();
			const response = await axiosInstance.post(change_password, payload);

			if (response.status == 401) {
				logout();
				navigate("/");
				return;
			}

			if (response.data?.user?.error) {
				setResponseError(response?.data?.user?.error);
				setAlertVisible(true);
			} else {
				setAlertVisible(true);
				setFormData({
					oldPassword: "",
					password: "",
					confirmPassword: "",
				});
			}
		} catch (err) {
			setResponseError("Some errors occured. Please try again later.");
			setAlertVisible(true);
			console.log(err);
		}finally{
			setLoading(false);
		}
	};

	return (
		<section className="authentication min-vh-100">
			<header className="p-4">
				<div className="container-fluid">
					<div className="card d-flex align-items-center logo-container">
						<LogoIcon />
					</div>
				</div>
			</header>
			<div className="container-fluid">
				<div className="row align-items-center min-vh-75  w-100">
					<div className="col-md-12 col-lg-12 col-xl-12">
						
						<div className="login-container">
							<div className="mb-3">
								{/* <LogoIcon /> */}
							</div>
							<h2 className="my-3 my-md-4" style={{color: "white", fontSize: "26px", fontWeight: '700', lineHeight: '40px', fontFamily: 'Roboto'}}> CHANGE PASSWORD</h2>
							{/* <p className="text-secondary">
								Have you already reset the password ? <a href="">Sign in</a>
							</p> */}
							<form action="" onSubmit={handleSubmit}>
								<div className="mb-3">
									<label htmlFor="floatingInput" className="form-label text-white mb-2">Please Enter Your Old Password</label>
									<input
										type="password"
										className={`form-control form-control-lg bg-white rounded-4 ${
											errors.password ? "is-invalid" : ""
										}`}
										id="floatingInput"
										// placeholder="********"
										name="oldPassword"
										value={formData.oldPassword}
										onChange={handleChange}
									/>
									
									{errors.password && (
										<div className="invalid-feedback">{errors.oldPassword}</div>
									)}
								</div>
								<div className="mb-3">
									<label htmlFor="floatingInput" className="form-label text-white mb-2">Enter Your NewPassword</label>
									<input
										type="password"
										className={`form-control form-control-lg bg-white rounded-4 ${
											errors.password ? "is-invalid" : ""
										}`}
										id="floatingInput"
										// placeholder="********"
										name="password"
										value={formData.password}
										onChange={handleChange}
									/>
									
									<div className="form-text text-start">
										<i className="bi bi-info-circle"></i> Use 8 or more
										characters with a mix of letters, numbers & symbols.
									</div>
									{errors.password && (
										<div className="invalid-feedback">{errors.password}</div>
									)}
								</div>
								<div className="mb-3">
									<label htmlFor="confirm-password" className="form-label text-white mb-2">Confirm Password</label>
									<input
										type="password"
										className={`form-control form-control-lg bg-white rounded-4 ${
											errors.confirmPassword ? "is-invalid" : ""
										}`}
										id="confirm-password"
										// placeholder="********"
										name="confirmPassword"
										value={formData.confirmPassword}
										onChange={handleChange}
									/>
									
									{errors.confirmPassword && (
										<div className="invalid-feedback">
											{errors.confirmPassword}
										</div>
									)}
								</div>
								{/* <div className="form-check  text-start mb-3">
									<input
										className="form-check-input"
										type="checkbox"
										value="1"
										name="agreed"
										id="flexCheckDefault"
										required
									/>
									<label
										className="form-check-label text-white"
										htmlFor="flexCheckDefault"
										style={{
											fontWeight: '400',
											fontSize: '14px',
											lineHeight: '100%'
										}}
									>
										I Agree &{" "}
										<a href="/terms-and-conditions">Terms and conditions</a>
									</label>
								</div> */}
								<br />
								<div className="d-flex flex-row flex-grow-1 gap-3 align-items-center">
									<div className="d-grid login-btn-container gap-2">
										<button 
											type="submit" 
											className="w-100 btn btn-rounded btn-secondary text-white fw-bold py-3"
											style={{
												// borderRadius: '10px',
												background: '#26397E',
												borderRadius: "77.125rem"
											}}
										>
											{loading ? <div
												className="d-flex justify-content-center align-items-center"
												style={{ height: "20px", color: 'white' }}
											>
												<div className="spinner-border text-white" role="status">
													<span className="visually-hidden">Loading...</span>
												</div>
											</div> : "SIGN IN"}
										</button>
									</div>
								</div>
								{responseError && <p>{responseError}</p>}
								<button className="mt-4 btn btn-link" onClick={() => navigate(-1)} style={{color: "white"}}>
									<i className="bi bi-arrow-left me-2"></i> Go Back
								</button>
							</form>
						</div>
						
					</div>
					{/* <Footer />
					<ChatHistory
						onNavigate={(path: string) => {
							navigate(path);
						}}
					/> */}
				</div>
				<div className="row">
					<div className="d-flex justify-content-end" style={{
						marginRight: '10%',
						paddingRight: '3%',
						marginTop: '1%'
					}}>
						<div className="text-white my-2 px-3">
							Powered By: 
						</div>
						<div className="card d-flex align-items-center logo-container">
								<LogoIcon />
						</div>
					</div>
				</div>
			</div>

			<div className="text-black d-flex flex-row gap-2 footer-container">
				Some information about the platform:
				<ul style={{
					listStyleType: 'none',
					paddingLeft: '0',
					marginLeft: '0',
					display: 'flex',
					flexDirection: 'row',
					gap: '10'
				}}>
					<li style={{borderRight: '1px solid black', paddingRight: '10px', textDecoration: 'underline', cursor: 'pointer'}} onClick={() => navigate("/terms-and-conditions")}> Terms & conditions </li>
					<li style={{borderRight: '1px solid black', paddingRight: '10px', textDecoration: 'underline', paddingLeft: '10px', cursor: 'pointer'}} onClick={() => navigate("/privacy-policy")}>Privacy Policy</li>
					<li style={{cursor: 'pointer', paddingLeft: '10px', textDecoration: 'underline'}} onClick={() => navigate("/disclaimer")}>Disclaimer</li>
				</ul>
			</div>
			<Alert
				message={`${
					responseError.length > 1
						? responseError
						: "Password Reset Successful."
				}`}
				type={`${responseError.length > 1 ? "danger" : "success"}`}
				show={alertVisible}
				onClose={() => setAlertVisible(false)}
			/>
		</section>
	);
};

export default ChangePassword;
